import React from "react";
import PropTypes from "prop-types";
import { PageHeader, Tabs } from "@opendate-app/setlist";
import StaffingTabs, { STAFFING_SUPPORTING_TEXT, staffingTabPathsShape } from "./StaffingTabs";

export const STAFFING_SETTINGS_PAGES = {
  general: "General",
  positions: "Positions",
  templates: "Templates",
  permissions: "Permissions",
};

const StaffingSettingsLayout = ({ current, title, description, actions, tabPaths, maxWidth, children }) => {
  const items = Object.entries(STAFFING_SETTINGS_PAGES)
    .filter(([value]) => tabPaths[value])
    .map(([value, label]) => ({ value, label }));

  return (
    <div className="od-themed" style={{ padding: 24 }}>
      <PageHeader title="Staffing" supportingText={STAFFING_SUPPORTING_TEXT} />
      <div className="mt-3">
        <StaffingTabs current="settings" paths={tabPaths} />
      </div>
      <div className="d-flex" style={{ flexWrap: "wrap", gap: 24, alignItems: "flex-start" }}>
        <nav aria-label="Staffing settings" style={{ flex: "0 0 168px" }}>
          <Tabs
            items={items}
            value={current}
            orientation="vertical"
            variant="button-gray"
            track={false}
            collapseBelow={0}
            onChange={(value) => {
              if (value !== current) window.location.href = tabPaths[value];
            }}
          />
        </nav>
        <div style={{ flex: "1 1 400px", minWidth: 0, maxWidth }}>
          <div className="d-flex" style={{ flexWrap: "wrap", gap: 12, justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
            <div style={{ maxWidth: 560 }}>
              <h2 style={{ fontSize: 18, lineHeight: "28px", fontWeight: 600, color: "var(--sl-text-primary)", margin: 0 }}>{title}</h2>
              {description && <p style={{ fontSize: 14, lineHeight: "20px", color: "var(--sl-text-tertiary)", margin: "4px 0 0" }}>{description}</p>}
            </div>
            {actions && <div className="d-flex" style={{ gap: 8, flexWrap: "wrap" }}>{actions}</div>}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

StaffingSettingsLayout.propTypes = {
  current: PropTypes.oneOf(Object.keys(STAFFING_SETTINGS_PAGES)).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actions: PropTypes.node,
  maxWidth: PropTypes.number,
  tabPaths: staffingTabPathsShape.isRequired,
  children: PropTypes.node,
};

export default StaffingSettingsLayout;
